import { render } from "./PackagesManager.vue?vue&type=template&id=26be93aa"
import script from "./PackagesManager.vue?vue&type=script&lang=js"
export * from "./PackagesManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__